import { render, staticRenderFns } from "./LabelEditorDialog.vue?vue&type=template&id=79a9a318"
import script from "./LabelEditorDialog.vue?vue&type=script&lang=ts"
export * from "./LabelEditorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports